import Folder from './Folder';

export {
  Folder,
};



// WEBPACK FOOTER //
// ./src/views/ReportList/utils/index.js